import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  Inject,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { CardTrabajosComponent } from '../card-trabajos/card-trabajos.component';
import { SwiperOptions } from 'swiper/types';
import { SwiperContainer } from 'swiper/element/bundle';

@Component({
    selector: 'app-trabajos-card-simple',
    imports: [
        CardTrabajosComponent
    ],
    templateUrl: './trabajos-card-simple.component.html',
    styleUrl: './trabajos-card-simple.component.css',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TrabajosCardSimpleComponent  implements AfterViewInit {
  @ViewChild('swiper') swiperRef!: ElementRef<SwiperContainer>;
  //navigation="true" slides-per-view="4"   free-mode="true"  grab-cursor="true"

  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  
  ngAfterViewInit(): void {
      if (!this.isBrowser || !this.swiperRef?.nativeElement) {
        return;
      }

      const swiperParams: SwiperOptions = {
        slidesPerView: 1,
        navigation: true, 
        grabCursor: true,
        freeMode: false, 
        spaceBetween: 10, 
        breakpoints: {
          320: {
            slidesPerView: 1,
            freeMode: false,
            loop: true
          },
          640: {
            slidesPerView: 2,
            freeMode: true,
            loop: false
          },
          1040: {
            slidesPerView: 3,
            freeMode: true,
            loop: false
          },
          1870: {
            slidesPerView: 4,
            freeMode: true,
            loop: false
          }
        }
      };

      Object.assign(this.swiperRef.nativeElement, swiperParams);

      const swiperElement = this.swiperRef.nativeElement as unknown as {
        initialize?: () => void;
      };

      if (typeof swiperElement.initialize === 'function') {
        swiperElement.initialize();
      }
     
  }
}
